// Components
import { Button, Checkbox, Input, Select } from "components"

// Types
import type { Filter } from "../types"

// Utils
import { useGroupList } from "../utils"

export function FilterSection(params: Filter): JSX.Element {
  // Vars
  const filter = params.filter

  return (
    <div className="lg:flex lg:justify-between items-center">
      <div className="lg:flex items-end gap-3">
        <Input
          label="SEARCH"
          className="lg:w-[300px] md:w-full"
          placeholder="Search data..."
          onChange={res => params.handleSearchGroup("search", res.target.value)}
        />
        
        <div className="flex items-center gap-3 lg:mb-3 mt-3">
          <Checkbox
            value={filter.buy}
            onChange={() => params.handleCheckbox("buy")}
          >
            BUY
          </Checkbox>

          <Checkbox
            value={filter.sell}
            onChange={() => params.handleCheckbox("sell")}
          >
            SELL
          </Checkbox>

          <Checkbox
            value={filter.inventory}
            onChange={() => params.handleCheckbox("inventory")}
          >
            INVENTORY
          </Checkbox>
        </div>
      </div>

      <div className="lg:flex lg:items-end">
        <ProductGroup
          value={filter.group_id}
          onChange={res => params.handleSearchGroup("group_id", res)}
        />

        <div className="w-full">
          <Button
            className="uppercase sm:rounded-lg border-white hover:border-primary hover:bg-primary hover:text-black mb-2 w-full"
            onClick={params.reset}
          >
            Lastest Item
          </Button>
        </div>
      </div>
    </div>
  )
}

function ProductGroup(params: {
  value: string
  onChange: (value: string) => void
}): JSX.Element {
  // Hooks
  const { data, isLoading } = useGroupList()

  return (
    <Select
      label="PRODUCT GROUP"
      placeholder="Select product group here..."
      className="lg:w-[300px] w-full me-2 mb-2"
      width={true}
      isLoading={isLoading}
      options={data}
      value={data.find(item => item.value === params.value)}
      onChange={e => {
        if (e) {
          params.onChange(e.value)
        }
      }}
    />
  )
}